import { IdName } from '@app/entities/interfaces/data/idname.interface';
import { QualificationStatus } from '@app/entities/interfaces/personal-data/studies.interface';
import { Country } from '@app/entities/models/geography/country.model';

export class Studies {
  qualifications!: Study[];
}

export class Study {
  startYear!: number;
  endYear: number | undefined;
  academy!: string;
  country!: Country;
  qualification!: IdName;
  educationalLevel!: IdName;
  qualificationStatus!: QualificationStatus;
}

export class QualificationStatuses {
  qualificationStatuses!: QualificationStatus[];
}

export class QualificationEducationalLevels {
  educationalLevels!: IdName[];
}

export class Qualification {
  data!: IdName[];
  pagination!: PaginationQualification;
}

export class PaginationQualification {
  requestedPage!: number;
  requestedSize!: number;
  retrievedResults!: number;
  totalResults!: number;
}
